import './vendor';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { AccountPanelCoreModule } from 'app/core/core.module';
import { AccountPanelSharedModule } from 'app/shared/shared.module';

import { AccountPanelAppRoutingModule } from './app-routing.module';
import { MainComponent } from './layouts/main/main.component';
import { PasswordExpireAdvisorModalComponent } from './layouts/main/password-expire-adv.modal.component';
import { ActiveMenuDirective } from './layouts/navbar/active-menu.directive';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { AccountPanelPagesModule } from './pages/pages.module';
import { appReducer } from './shared/state/app.reducer';
import { Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';
import { TwoFactorClientExpireAdvisorModalComponent } from './layouts/main/twofactor-client-expire-adv.modal.component';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { PecConversionExpireAdvisorModalComponent } from './layouts/main/pec-conversion-expire-adv.modal.component';
import { PecConversion3ExpireAdvisorModalComponent } from './layouts/main/pec-conversion3-expire-adv.modal.component';
import { ToastService } from './shared/service/toast.service';
import { PecConversionDocaposteAdvisorModalComponent } from './layouts/main/pec-conversion-docaposte-adv.modal.component';
import { SCROLL_OFFSET } from './shared/constants/offset.constants';

@NgModule({
  providers: [ToastService],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AccountPanelSharedModule,
    AccountPanelCoreModule,
    AccountPanelPagesModule,
    AccountPanelAppRoutingModule,
    StoreModule.forRoot({ app: appReducer }),
  ],
  declarations: [
    MainComponent,
    NavbarComponent,
    SidebarComponent,
    ActiveMenuDirective,
    PasswordExpireAdvisorModalComponent,
    TwoFactorClientExpireAdvisorModalComponent,
    PecConversionExpireAdvisorModalComponent,
    PecConversion3ExpireAdvisorModalComponent,
    PecConversionDocaposteAdvisorModalComponent,
  ],
  bootstrap: [MainComponent],
})
export class AccountPanelAppModule {
  constructor(router: Router, viewportScroller: ViewportScroller, ngbModalService: NgbModalConfig) {
    ngbModalService.backdrop = 'static';
    ngbModalService.keyboard = false;

    viewportScroller.setOffset(SCROLL_OFFSET);
    router.events.pipe(filter((e): e is Scroll => e instanceof Scroll)).subscribe((e: Scroll) => {
      if (e.anchor) {
        setTimeout(() => {
          viewportScroller.scrollToAnchor(e.anchor || '');
        });
      } else if (e.position) {
        viewportScroller.scrollToPosition(e.position);
      } else {
        viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
}
